import { Component, OnInit, AfterViewInit } from '@angular/core';
import { FormComponentLookup } from '@ptl/forms';
import { IndividualMarketStateStructure } from '../../plan-enrollment/individual-plan-enrollment-form/configs/interfaces/individualMarket.interfaceStateStructure';
import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';
import { AddControlService } from './add-control.service';
import { FormEntryComponentClass } from '@ptl/forms';

@FormComponentLookup('add-controls')
@Component({
    selector: 'app-add-controls',
    templateUrl: './add-controls.component.html',
    styleUrls: ['./add-controls.component.scss'],
    standalone: false
})
export class AddControlsComponent extends FormEntryComponentClass implements OnInit, AfterViewInit {

  count: number;
  constructor(
    private addControlService: AddControlService,
    private reducerUtilService: ReducerUtilityService
  ) {
    super();
    this.count = 1;
  }
  ngAfterViewInit(): void {
    this.initTriggers();
    this.setFormControlValidators();
    this.setDefaultValue();
  }

  /**
   * @description Sets up formListeners and formBroadcasters
   */
  initTriggers() {

    this.subscribeToFormStream(this.entry.base.formListeners);
    this.broadcastToFormStream(this.entry.base.formBroadcast);

  }

  ngOnInit(): void {

  }

  /** This will add controls (in the form config way), and provide an unique identifier of "XXXX-1", "XXXX-2", ..., "XXXX-n" */
  addControls() {
    const individualMarketPayload: IndividualMarketStateStructure = this.reducerUtilService.getPayloadState('individualMarket');
    this.count = individualMarketPayload.individualMarketEligibility.count;
    this.addControlService.addControls(this.entry, this.count, this.currentPage, this.form);
  }

}
